export const SERVICES = {
  service1: {
    name: 'React',
    icon: 'bi-percent',
    info:
      'We create fast and good quality single page applications in varaity of frameworks such as React, Angular, etc.',
    link: 'react',
  },
  service2: {
    name: 'Wordpress',
    icon: 'bi-code-slash',
    info:
      'We do create websites that are fast and flexible in content management systems such as Wordpress.',
    link: 'wordpress',
  },
  service3: {
    name: 'E-Commerce',
    icon: 'bi-bag',
    info:
      'We develop e-commerece websites that are reliable and helps you develop you online business.',
    link: 'ecommerce',
  },
  service4: {
    name: 'UI/UX and Logo Design',
    icon: 'bi-file-image',
    info:
      'We design and create beautiful layout that are flexible and functional, and all kinds of Logos.',
    link: 'graphics',
  },
  service5: {
    name: 'Application',
    icon: 'bi-phone',
    info:
      'We create flexible and responsive apps that works with all modern phone & tablets using tools such as React-native and Flutter.',
    link: 'applications',
  },
  service6: {
    name: 'SEO',
    icon: 'bi-search',
    info:
      'We help websites to become more visible online, which in terms helps your business to grow faster.',
    link: 'seo',
  },
};